module.exports = __webpack_public_path__ + "media/images/emblems/Capriasca-coat_of_arms-a700eef07f758f23fc2b26824a9df3e1.svg";